import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { tab } from "../BrandScore/BrandScore";

import { useContext, useEffect } from "react";

import { DiscoveryContext, useIsSelectedSection } from "../discovery-context";
import { ActionTable } from "../../Dashboard/Component/ActionComponent/ActionTable";
import { extractDomain } from "../../../utils/helpers";
import { callingForExtFocusAreasForBrandAudit } from "../../../utils/actions-helpers";
import Checkbox from "@mui/material/Checkbox";

const titleMapping = {
  reach: "Reach",
  risk: "Performance",
  sentiment: "Risk",
};

function roundNumber(num) {
  return num % 1 < 0.5 ? Math.floor(num) : Math.ceil(num);
}

const FocusAreaOverView = ({category,isCategoryOverview=false}) => {
  const [brandDomains, setBrandDomains] = useState([]);
  const discoveryCtx = useContext(DiscoveryContext);
  let llm = [discoveryCtx.state.selectedLLM];
  let Category = [category ? category : discoveryCtx.state.selectedCategory];
  // let market=[discoveryCtx.state.selectdMarket];
   let market=[discoveryCtx.markets[0]];
  const id = "FocusArea_Overview";
  const { checked, uniqueKey } = useIsSelectedSection({ id });

  let outputArr = [];
  llm.forEach((selectedLLM) => {
    Category.forEach((selectedCategory) => {
      let marketWise = market.map((selectedMarket) => {
        let obj = {
          llm: selectedLLM,
          category: selectedCategory,
          market: selectedMarket,
          brand: discoveryCtx.entity,
        };
        const brandScore =
          discoveryCtx.brand_scores?.[selectedLLM]?.[selectedCategory]?.[
            selectedMarket
          ] ?? [];
        const categoryDimension =
          discoveryCtx.category_dimensions?.[selectedLLM]?.[selectedCategory] ??
          [];
        const coreAttributes =
          discoveryCtx?.core_attributes?.[selectedLLM]?.[selectedCategory] ??
          [];
        const taxonomy =
          discoveryCtx?.taxonomies?.[selectedLLM]?.[selectedCategory] ?? [];
        const competitors = discoveryCtx.competitors?.[selectedCategory] ?? [];

        const output = callingForExtFocusAreasForBrandAudit({
          coreAttributes,
          taxonomy,
          categoryDimension,
          brandScore,
          competitors,
        });

        return {
          ...obj,
          ...output.actionsObj,
          nonActionsObj: output.nonActionsObj,
        };
      });
      outputArr.push(...marketWise);
    });
  });

  useEffect(() => {
    let domain = extractDomain(
      discoveryCtx?.competitors?.["default"]?.[0]?.domain ?? "example.com"
    );
    setBrandDomains({ [discoveryCtx.entity]: domain });
  }, [discoveryCtx.competitors]);

  // console.log("discoveryCtx", discoveryCtx);
  return (
   <>
   <br/>
     {!isCategoryOverview &&<div className="Heading-checkbox" style={{marginBottom:'10px'}}>
           <h5>Focus Area</h5>
   
           {discoveryCtx.state.showReportCheckbox && (
             <Checkbox
               checked={checked}
               onChange={() => {
                 discoveryCtx?.clickComponentCheckbox({
                   uniqueKey,
                   filter: {
                     id: id,
                     title: "Focus Area",
                     tab: tab.brandOverview,
                     uniqueKey
                   },
                   checked,
                   id,
                 });
               }}
               inputProps={{ "aria-label": "controlled" }}
             />
           )}
         </div>}
   


      <Grid container spacing={1}>
        <ActionTable
          handleChange={() => {}}
          tableType="opp"
          actionMetricsData={outputArr}
          sourceAliasIds={"sourceAliasIds"}
          domaUrlsMapping={brandDomains}
          isBrandAudit={true}
          id={id}
        />
      </Grid>
      <ToastContainer />
    </>
  );
};

export default FocusAreaOverView;
